import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { WEBPAGE_TITLE } from "@utils/constants";

function ServiceNumber() {
    return (
        <>
            <Head>
                <title key="site_title">Vöktun samfélagsmiðla - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection containerStyle={{ padding: 30 }}>
                <ServiceHeader
                    image="/img/thjonusta/voktun-samfelagsmidla.png"
                    title="Vöktun samfélagsmiðla"
                />
                <p style={{ marginTop: 63, clear: "both" }}>
                    1819 tekur a&eth; s&eacute;r a&eth; sj&aacute; alfari&eth; um v&ouml;ktun og
                    eftirfylgni &aacute; samf&eacute;lagsmi&eth;lum fyrirt&aelig;kja. &THORN;egar
                    fyrirt&aelig;ki n&yacute;ta s&eacute;r samf&eacute;lagsmi&eth;lav&ouml;ktun 1819
                    &thorn;&aacute; getur &thorn;a&eth; spara&eth; starfsm&ouml;nnum mikinn
                    t&iacute;ma og gefur &thorn;eim svigr&uacute;m fyrir meira
                    &aacute;r&iacute;&eth;andi verkefni. Leyf&eth;u okkur a&eth; sj&aacute; um
                    samf&eacute;lagsmi&eth;lana fyrir &thorn;ig!
                    <br />
                    <br />
                    &Iacute; auknum m&aelig;li s&aelig;kja vi&eth;skiptavinir
                    samf&eacute;lagsmi&eth;la fyrirt&aelig;kja til &thorn;ess a&eth; kynna
                    s&eacute;r v&ouml;rur og &thorn;j&oacute;nustu, sko&eth;a augl&yacute;singar
                    e&eth;a senda fyrirspurnir. Af &thorn;eirri &aacute;st&aelig;&eth;u ver&eth;a
                    samf&eacute;lagsmi&eth;larnir eins og spegilmynd fyrit&aelig;kisins.
                    Atvinnurekendur &thorn;urfa a&eth; gera s&eacute;r grein fyrir mikilv&aelig;gi
                    &thorn;essa hlutar marka&eth;arins sem eykst or&eth;i&eth; me&eth; &aacute;ri
                    hverju. A&eth; halda uppi notendav&aelig;num samf&eacute;lagsmi&eth;lum og
                    g&oacute;&eth;ri &thorn;j&oacute;nustu vi&eth; vi&eth;skiptavini &thorn;ar er
                    langhlaup en ekki spretthlaup.
                </p>
                <p>&nbsp;</p>
                <p>
                    Ýmsar &aacute;st&aelig;&eth;ur geta legi&eth; a&eth; baki &thorn;ess a&eth;
                    fyrirt&aelig;ki geti ekki sinnt samf&eacute;lagsmi&eth;lum eins og best
                    v&aelig;ri &aacute; kosi&eth;. &THORN;ar spila t&iacute;maskortur og
                    &thorn;ekkingarleysi &aacute; umhverfi samf&eacute;lagsmi&eth;la oft
                    st&oacute;rt hlutverk. Vi&eth; sl&iacute;kar a&eth;st&aelig;&eth;ur er gott
                    a&eth; s&aelig;kja s&eacute;r utana&eth;komandi a&eth;sto&eth; me&eth;
                    &thorn;v&iacute; a&eth; &uacute;tvista v&ouml;ktun og eftirfylgni
                    samf&eacute;lagsmi&eth;la &iacute; hendur s&eacute;rfr&aelig;&eth;inga okkar.
                    &THORN;a&eth; sparar &thorn;&iacute;nu fyrirt&aelig;ki mannafla, t&iacute;ma og
                    fyrirh&ouml;fn a&eth; f&aacute;
                    samf&eacute;lagsmi&eth;las&eacute;rfr&aelig;&eth;inga 1819 &iacute;
                    m&aacute;li&eth;!
                </p>
                <p style={{ textAlign: "center" }}>
                    <a className="btn btn-primary" href="/hafa-samband">
                        Hafa samband
                    </a>
                </p>{" "}
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
